<template>
  <div class="dashboard-container">
    <div>
      <el-row style="margin-bottom:0">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="account">
              <div class="svg_03"><svg t="1582703573340" class="icon" viewBox="0 0 1184 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6374" width="64" height="64"><path d="M1005.633722 616.006249c-5.311502-0.479955-10.431022-1.27988-15.518545-2.143799-1.087898-0.127988-2.271787-0.287973-3.359685-0.479955-2.399775-0.415961-4.671562-1.055901-7.007343-1.631847-9.951067-2.143799-19.678155-4.831547-28.989282-8.351217l0 133.235509-731.355435 0 0-133.235509c-9.375121 3.551667-19.006218 6.303409-29.053276 8.511202-2.335781 0.415961-4.607568 1.055901-6.943349 1.535856-1.087898 0.191982-2.175796 0.31997-3.359685 0.511952-5.11952 0.767928-10.271037 1.535856-15.518545 2.079805-5.983439 0.479955-12.094866 0.863919-18.270287 0.863919-12.47883 0-24.701684-1.215886-36.540574-3.327688l0 357.310502c0 29.309252 24.573696 53.11502 54.874855 53.11502l841.073149 0c30.237165 0 54.810861-23.773771 54.810861-53.11502l0-357.342499c-11.83889 2.143799-24.061744 3.327688-36.540574 3.327688-6.07943 0-12.254851-0.351967-18.23829-0.863919z" fill="#e6e6e6" p-id="6375"></path><path d="M182.83086 109.749711l804.500578 0c30.301159 0 54.874855-24.573696 54.874855-54.874855s-24.573696-54.874855-54.874855-54.874855l-804.500578 0c-30.301159 0-54.874855 24.573696-54.874855 54.874855 0.031997 30.301159 24.605693 54.874855 54.874855 54.874855z" fill="#e6e6e6" p-id="6376"></path><path d="M1067.387932 164.592569l-964.549573 0-102.838359 256.007999c0 80.728432 65.529857 146.258288 146.258288 146.258288s146.258288-65.529857 146.258288-146.258288c0 80.728432 65.529857 146.258288 146.258288 146.258288s146.258288-65.529857 146.258288-146.258288c0 80.728432 65.529857 146.258288 146.258288 146.258288s146.258288-65.529857 146.258288-146.258288c0 80.728432 65.529857 146.258288 146.258288 146.258288s146.258288-65.529857 146.258288-146.258288l-102.806362-256.007999z" fill="#e6e6e6" p-id="6377"></path></svg></div>
              <div class="numbertotal_01">
                <div>{{shopCounts}}</div>
                <div>总商户数(个)</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="account">
               <div class="svg_02"><svg t="1582703482356" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4809" width="64" height="64"><path d="M860.16 0C950.272 0 1024 73.889684 1024 164.163368v531.509895s-32.768-4.122947-180.224-53.355789c-40.96-14.362947-96.256-34.896842-157.696-57.478737 36.864-63.595789 65.536-137.485474 86.016-215.444211h-202.752v-71.841684h247.808V256.512h-247.808V135.437474h-100.352c-18.432 0-18.432 18.458947-18.432 18.458947v104.663579H200.704v41.040842h249.856v69.793684H243.712v41.013895H645.12c-14.336 51.307789-34.816 98.519579-57.344 141.608421-129.024-43.115789-268.288-77.985684-356.352-55.403789-55.296 14.362947-92.16 38.992842-112.64 63.595789-96.256 116.978526-26.624 295.504842 176.128 295.504842 120.832 0 237.568-67.718737 327.68-178.526316C757.76 742.858105 1024 853.692632 1024 853.692632v6.144C1024 950.110316 950.272 1024 860.16 1024H163.84C73.728 1024 0 950.137263 0 859.836632V164.163368C0 73.889684 73.728 0 163.84 0h696.32zM268.126316 553.121684c93.049263-10.374737 180.062316 26.974316 283.270737 78.874948-74.886737 95.501474-165.941895 155.701895-256.970106 155.701894-157.830737 0-204.368842-126.652632-125.466947-197.200842 26.300632-22.851368 72.838737-35.301053 99.166316-37.376z" fill="#e6e6e6" p-id="4810" data-spm-anchor-id="a313x.7781069.0.i32" class="selected"></path></svg></div>
              <div class="numbertotal_02">
                <div>{{aliCounts}}</div>
                <div>支付宝直连商家数(个)</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="account">
              <div class="svg_01"><svg t="1582703452533" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3965" width="64" height="64"><path d="M578.88655 517.146597a24.310026 24.310026 0 0 0-23.059948 23.937663 23.937662 23.937662 0 0 0 23.059948 21.410909 26.796883 26.796883 0 0 0 29.656104-21.410909 26.677195 26.677195 0 0 0-29.656104-23.937663z m-75.802598-111.230337a27.461818 27.461818 0 0 0 29.656104-28.844883 27.062857 27.062857 0 0 0-29.656104-28.831585 30.959377 30.959377 0 0 0-33.765402 28.831585 31.504623 31.504623 0 0 0 33.765402 28.844883zM512.180264 11.849143a505.696416 505.696416 0 1 0 505.523532 505.709714A505.616623 505.616623 0 0 0 512.180264 11.849143z m-95.53787 633.829402a272.290909 272.290909 0 0 1-81.547637-13.192311l-83.183376 42.023896 23.937662-70.855481c-58.514286-41.225974-93.090909-93.090909-93.090909-156.539013 0-112.054857 105.432104-197.73839 233.910857-197.738389 113.664 0 214.973506 67.557403 234.735377 163.148467a114.102857 114.102857 0 0 0-22.235429-2.473558c-112.014961 0-198.496416 84.034494-198.496415 185.383896a198.695896 198.695896 0 0 0 6.64935 49.444571 172.883117 172.883117 0 0 1-20.599688 0.82452z m343.465558 80.736416l16.463792 59.325507-62.596987-35.427741a355.155117 355.155117 0 0 1-70.828883 12.354494c-110.379221 0-197.671896-75.802597-197.671896-169.718026s87.305974-169.731325 197.671896-169.731325c104.607584 0 198.496416 75.802597 198.496416 169.731325 0 52.729351-35.414442 99.74026-81.534338 133.465766zM340.041874 348.239792a32.502026 32.502026 0 0 0-35.414441 28.831585 33.100468 33.100468 0 0 0 35.414441 28.844883 28.352831 28.352831 0 0 0 29.656104-28.844883 27.927273 27.927273 0 0 0-29.656104-28.831585z m368.174546 168.893507a23.738182 23.738182 0 0 0-23.059948 23.937662 23.339221 23.339221 0 0 0 23.059948 21.410909 26.451117 26.451117 0 0 0 28.831584-21.410909 26.371325 26.371325 0 0 0-28.831584-23.937662z m0 0" fill="#e6e6e6" p-id="3966" data-spm-anchor-id="a313x.7781069.0.i27" class="selected"></path></svg></div>
              <div class="numbertotal_03">
                <div>{{wxCounts}}</div>
                <div>微信直连商家数(个)</div>
              </div>
            </div>
          </div>
        </el-col>
          <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="account">
              <div class="svg_04"><svg t="1582704829504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7617" width="64" height="64"><path d="M107.7 418.8c10 0 19.6 1.5 28.7 4.2 40.2-167.7 191.3-292.5 371.1-292.5 61.4 0 119.5 14.6 170.9 40.5 5.9-19.6 17.5-36.6 33-49.2-10.6-5.6-21.5-10.7-32.5-15.4-54.3-23-112-34.6-171.3-34.6-59.4 0-117.1 11.6-171.3 34.6-52.4 22.1-99.5 53.9-140 94.4s-72.1 87.5-94.4 140c-11.4 27.1-20 54.8-25.8 83.4 9.9-3.6 20.6-5.4 31.6-5.4z m536.5 449.3c-42.5 16.4-88.6 25.4-136.7 25.4-174.4 0-321.8-117.6-367.2-277.6-10.3 3.5-21.2 5.3-32.6 5.3-9.6 0-19-1.4-27.8-3.9 5.6 22.4 12.8 44.5 21.9 65.9 22.1 52.4 53.9 99.5 94.4 140s87.5 72.1 140 94.4c54.3 23 112 34.6 171.3 34.6 56.6 0 111.7-10.6 163.8-31.5-13.8-14.2-23.4-32.3-27.1-52.6z m268.9-527.6c-13.4-31.8-30.4-61.5-50.6-89-10.3 17.3-25.5 31.3-43.7 40.1C863 353.8 889 430 889 511.9c0 95.9-35.6 183.7-94.3 250.9 17.3 10.1 31.5 25.3 40.3 43.4 32.8-36.4 59-77.7 78.2-122.9 23-54.3 34.6-112 34.6-171.3s-11.7-117.2-34.7-171.5z" p-id="7618" fill="#e6e6e6"></path><path d="M670 206.6c0 47.4 38.3 85.8 85.7 85.8 47.4 0 85.8-38.3 85.8-85.7v-0.1c0-47.4-38.3-85.8-85.7-85.8-47.4 0-85.8 38.3-85.8 85.7v0.1zM701.8 854.6c0 47.4 38.3 85.8 85.7 85.8 47.4 0 85.8-38.3 85.8-85.7v-0.1c0-47.4-38.3-85.8-85.7-85.8-47.4 0-85.8 38.3-85.8 85.7v0.1zM40.9 569.9c0 47.4 38.4 85.8 85.8 85.8s85.8-38.4 85.8-85.8-38.4-85.8-85.8-85.8-85.8 38.4-85.8 85.8zM795 384.8c0-14.4-10.8-30.4-25.1-35.9-71.7-32.2-204.3-84.2-243.9-84.2-48.4 0-236.6 80.6-243.9 82.4-14.4 7.1-25.1 21.5-25.1 37.6 1.8 55.6-7.1 137.9 23.3 211.4 68.2 159.4 208 234.6 242 241.8h7.1c39.4-8.9 175.7-91.3 240.2-241.8 32.7-73.5 23.7-155.9 25.4-211.3zM615.8 569.2c10.8 0 17.9 7.1 17.9 17.9 0 10.7-7.1 17.9-17.9 17.9H544v53.8c0 10.7-7.1 17.9-17.9 17.9-10.8 0-17.9-7.1-17.9-17.9v-53.7h-71.7c-10.8 0-17.9-7.1-17.9-17.9 0-10.7 7.1-17.9 17.9-17.9h71.7v-35.9h-71.7c-10.8 0-17.9-7.1-17.9-17.9 0-10.8 7.1-17.9 17.9-17.9H476l-37.6-62.7c-5.3-8.9-1.8-19.7 7.1-23.3 8.9-5.3 19.7-1.8 25.1 7.1l48.4 80.6h16.1l48.4-80.6c5.3-8.9 16.1-10.8 25.1-7.1 8.9 5.3 10.8 16.1 7.1 23.3l-39.4 62.7h39.4c10.8 0 17.9 7.1 17.9 17.9 0 10.7-7.1 17.9-17.9 17.9H544v35.9h71.7c0.1 0 0.1-0.1 0.1-0.1z" p-id="7619" data-spm-anchor-id="a313x.7781069.0.i54" class="" fill="#e6e6e6"></path></svg></div>
              <div class="numbertotal_04">
                <div>{{yzCounts}}</div>
                <div>云纵商家数(个)</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 柱状图 -->
    <el-row>
      <el-col :span="8">
        <div class="grid-content bg-purple" id="boxShadow">
          <div v-if="shopCharge.length===0" class="Nodata">
            <div>今日收费商户排行</div>
            <div>
              <img src="../../assets/img/nodata_02.png" alt />
              <div>暂无数据</div>
            </div>
          </div>
          <div v-else style="100%;">
            <Histograms :shopCharge="shopCharge" />
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div id="boxs_02">
          <div class="legend">分润记录</div>
          <div class="tablename">
            <div>创建时间</div>
            <div>商户</div>
            <div>服务商</div>
          </div>
          <div v-if="realTimeOrder.length===0" class="Nodata2">
            <div>
              <img src="../../assets/img/nodata_02.png" alt />
              <div>暂无数据</div>
            </div>
          </div>
          <div v-else style="width:100%;">
            <WheelPlant :ParkData="realTimeOrder" />
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div id="boxs_05">
          <div class="legend">实时收费</div>
          <div class="table">
            <div>创建时间</div>
            <div>商户</div>
            <div>金额（元）</div>
          </div>
          <div v-if="realTimeTrade.length===0" class="Nodata2">
            <div>
              <img src="../../assets/img/nodata_02.png" alt />
              <div>暂无数据</div>
            </div>
          </div>
          <div v-else style="width:100%;margin-top:10px">
            <WheelPlant :ParkData="realTimeTrade" sign="true"/>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple" id="boxs">
           <div v-if="lastTenDaysCharge.length===0" class="Nodata">
            <div>近十日收费记录</div>
            <div>
              <img src="../../assets/img/nodata_02.png" alt />
              <div>暂无数据</div>
            </div>
          </div>
          <div v-else>
            <Echart :lastTenDaysCharge="lastTenDaysCharge" />
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple" id="boxs_04">
          <div class="order">今日支付笔数(笔)</div>
          <PieChart :toDayCountRatio="toDayCountRatio" :id="id" company="笔"/>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple-light" id="boxs_03">
          <div class="order">今日收费金额(元)</div>
          <PieChart :toDayCountRatio="toDayChargeRatio" :id="id2" company="元"/>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { TweenLite } from 'gsap';
import { mapGetters } from "vuex";
import Echart from "../../components/figure/echart.vue";
import Histograms from "../../components/figure/Histograms.vue";
import PieChart from "../../components/figure/PieChart.vue";
import WheelPlant from "../../components/figure/wheelPlant.vue";
export default {
  components: {
    Echart,
    PieChart,
    Histograms,
    WheelPlant
  },
  data() {
    return {
      headerName: "统计",
      // 饼状图
      toDayCountRatio: {}, //收费金额
      toDayChargeRatio: {}, //支付单数
      id: "piechart",
      id2: "piechart2",
      // 柱状图，十日分析
      lastTenDaysCharge: [],
      // 商户排行
      shopCharge: [],
      // 分润历史
      realTimeOrder: [],
      // 实时付费
      realTimeTrade: [],
      shopCount: "", //已拓展商户数
      yzCount: "", //已拓展云纵数
      aliCount: "", //已拓展支付宝直连商家数
      wxCount: "", //已拓展微信直连商家数
      shopCountNumber:0,//临时数据
      projectCountNumber:0,//临时数据
      aliCountNumber:0,//临时数据
      wxCountNumber:0,//临时数据
    };
  },
  computed: {
    ...mapGetters(["name"]),
    shopCounts() {
      //入场数量
      return this.shopCountNumber.toFixed(0);
    },
    yzCounts() {
      //入场数量
      return this.projectCountNumber.toFixed(0);
    },
    aliCounts() {
      //入场数量
      return this.aliCountNumber.toFixed(0);
    },
    wxCounts() {
      //入场数量
      return this.wxCountNumber.toFixed(0);
    },
  },
  watch: {
    shopCount(newValue) {
      TweenLite.to(this.$data, 1, { shopCountNumber: newValue });
    },
    yzCount(newValue) {
      TweenLite.to(this.$data, 1, { projectCountNumber: newValue });
    },
    aliCount(newValue) {
      TweenLite.to(this.$data, 1, { aliCountNumber: newValue });
    },
    wxCount(newValue) {
      TweenLite.to(this.$data, 1, { wxCountNumber: newValue });
    },
  },
  created() {
    this.getDataAll();
  },
  destroyed(){
    clearTimeout(this.setTime)  
  },
  methods: {
    //今日收费比例
    getDataAll() {
      // 今日收费比例
      this.$axios.post("dataCenter/toDayRatio").then(res => {
        if (res.data.state === 1) {
          this.toDayCountRatio = res.data.toDayCountRatio; //收费单数
          res.data.toDayChargeRatio.map(item => {
            item.value = item.value / 100;
            return item;
          });
          this.toDayChargeRatio = res.data.toDayChargeRatio; //支付金额
        }
      });
      // 近十日收费记录
      this.$axios.post("dataCenter/lastTenDaysCharge").then(res => {
        if (res.data.state === 1) {
          this.lastTenDaysCharge = res.data.lastTenDaysCharge; //收费金额
        }
      });
      // 今日收费商户排行
      this.$axios.post("dataCenter/toDayChargeTop5").then(res => {
        if (res.data.state === 1) {
          const shopTbMap = res.data.shopTbMap;
          const toDayCharge = res.data.toDayChargeTop5;
          this.shopCharge = [];
          for (let i in toDayCharge) {
            this.shopCharge.push({
              value: toDayCharge[i],
              name: shopTbMap[i] ? shopTbMap[i] : ""
            });
          }
          this.shopCharg=this.bSort(this.shopCharge)
        }
      });
      // 实时订单
      this.$axios.post("/dataCenter/realTimeOrder").then(res => {
        if (res.data.state === 1) {
          res.data.realTimeOrder.map(item => {
            item.create_time = this.getTiem(item.create_time);
            return item;
          });
          this.realTimeOrder = res.data.realTimeOrder;
        }
      });
      // 实时收费
      this.$axios.post("/dataCenter/realTimeTrade").then(res => {
        if (res.data.state === 1) {
          res.data.realTimeTrade.map(item => {
            item.total = item.total/100
            item.create_time = this.getTiem(item.create_time);
            return item;
          });
          this.realTimeTrade = res.data.realTimeTrade;
        }
      });
      // 已拓展商户数
      this.$axios.post("/dataCenter/shopCount").then(res => {
        if (res.data.state === 1) {
          this.shopCount = res.data.shopCount.count;
        }
      });
      // 已拓展云纵数
      this.$axios.post("/dataCenter/yzCount").then(res => {
        if (res.data.state === 1) {
          this.yzCount = res.data.yzCount.count;
        }
      });
      // 已拓展支付宝直连商家数
      this.$axios.post("/dataCenter/aliCount").then(res => {
        if (res.data.state === 1) {
          this.aliCount = res.data.aliCount.count;
        }
      });
      // 已拓展支付宝直连商家数
      this.$axios.post("/dataCenter/wxCount").then(res => {
        if (res.data.state === 1) {
          this.wxCount = res.data.wxCount.count;
        }
      });
      this.setTime = setTimeout(this.getDataAll, 60000);
    },
    // 时间转换
    getTiem(params) {
      let unixTimestamp = new Date(params * 1000); //时间戳转换成日期
      // 定义转换返回方式
      Date.prototype.toLocaleString = function() {
        return (
          this.getFullYear() +
          "年" +
          (this.getMonth() + 1) +
          "月" +
          +this.getDate() +
          "日" +
          " " +
          this.getHours() +
          "时" +
          this.getMinutes() +
          "分"
        );
      };
      params = unixTimestamp.toLocaleString();
      return params;
    },
    // 排序
    bSort(arr) {
      var len = arr.length;
      for (var i = 0; i < len-1; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
             // 相邻元素两两对比，元素交换，大的元素交换到后面
            if (+arr[j].value > +arr[j + 1].value) {
                var temp = arr[j];
                arr[j] = arr[j+1];
                arr[j+1] = temp;
            }
        }
      }
      return arr;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.grid-content > p {
  margin-left: 10px;
}

.merchants {
  display: flex;
  padding-left: 20px;
  padding-top: 10px;
  border: 1px solid;
}
.merchants > img {
  width: 8%;
  height: 8%;
}
.merchants > div {
  margin-left: 10px;
}
.merchants > div > p {
  margin-top: 5px;
}
.merchants > div > p:first-child {
  margin: 0;
}
.merchants > div > :nth-child(2) {
  margin-bottom: 41px;
}

#boxShadow {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 20px;
  width: 98%;
  height: 300px;
  background-color: #fff;
}
#boxShadow > div {
  width: 100%;
}
#boxs {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 10px;
  width: 99%;
  height: 300px;
  background-color: #fff;
}
#boxs > div {
  width: 100%;
}
#boxs_02 {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 20px;
  width: 99%;
  height: 300px;
  background-color: #fff;
}
.boxs_02 > div {
  width: 100%;
}
#boxs_03 {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 10px;
  width: 99%;
  margin-left: 1%;
  height: 300px;
  position: relative;
  background-color: #fff;
}
#boxs_03 > div {
  width: 100%;
}
#boxs_04 {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 10px;
  width: 99%;
  height: 300px;
  position: relative;
  background-color: #fff;
}
#boxs_04 > div {
  width: 100%;
}
.order{
   position: absolute;
  font-size: 14px;
  font-weight: 600;
}
#boxs_05 {
  box-shadow: 1px 1px 5px #ccc;
  padding: 10px;
  margin-top: 20px;
  width: 99%;
  height: 300px;
  margin-left: 1%;
  background-color: #fff;
}
.table {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}
.table > div:first-child {
  width: 35%;
  text-align: center;
}
.table > div:nth-child(2) {
  width: 35%;
  text-align: center;
}
.table > div:nth-child(3) {
  width: 20%;
  text-align: center;
}
.account {
  width: 99.5%;
  height: 90px;
  display: flex;
  border: 1px solid #F3F3F3;
  box-shadow: 2px 2px 10px #ccc;
  background-color: #fff;
  margin: 0;
}

.svg_01,
.svg_02,
.svg_03,
.svg_04 {
  width: 80px;
  text-align: center;
  height: 88px;
  line-height: 88px;
  vertical-align: middle;
}
.svg_01>svg,
.svg_02>svg,
.svg_03>svg,
.svg_04>svg{
  width: 80%;
} 
.svg_01 {
  background-color: #0AC02B;
}
.svg_02 {
  background-color: #00B1F9;
}
.svg_03 {
  background-color: #fb6e51;
}
.svg_04 {
  background-color: #f5b252;
}
.svg_01,.svg_02,.svg_03,.svg_04{
  padding-top: 12px;
}
.numbertotal_01,
.numbertotal_02,
.numbertotal_03,
.numbertotal_04 {
  width: 80%;
  text-align: center;
}
.numbertotal_01 > div,
.numbertotal_02 > div,
.numbertotal_03 > div,
.numbertotal_04 > div {
  margin-top: 9px;
  color: #8a8a8a;
  font-size: 14px;
}
.numbertotal_01 > div:nth-child(1),
.numbertotal_02 > div:nth-child(1),
.numbertotal_03 > div:nth-child(1),
.numbertotal_04 > div:nth-child(1) {
  font-size: 32px;
}
.numbertotal_01 > div:nth-child(1){
    color: #fb6e51;
}
.numbertotal_02 > div:nth-child(1){
    color: #00B1F9;
}
.numbertotal_03 > div:nth-child(1){
    color: #0AC02B;
}
.numbertotal_04 > div:nth-child(1){
    color: #F5B252;
}
// 
.lianjie {
  width: 17%;
  text-align: center;
  border-bottom: 1px solid #ccc;
}
.lianjie:hover {
  color: blue;
}
.legend {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}
.el-row[data-v-cc3c6ac8] {
  margin:0 0 20px;
}
// 暂无数据开始
.Nodata {
  width: 100%;
  height: 240px;
  color: #333;
  font-size: 14px;
  font-weight: 600;
  position: relative;
}
.Nodata > div:nth-child(2) {
  width: 80px;
  position: absolute;
  left: 40%;
  top: 30%;
  font-size: 10px;
  color: #ccc;
}
.Nodata > div > img {
  width: 100%;
}
.Nodata > div > div {
  text-align: center;
}
.Nodata2 {
  width: 15%;
  height: 200px;
  position: relative;
}
.Nodata2 > div {
  width: 100%;
  position: absolute;
  left: 260%;
  top: 20%;
  font-size: 10px;
  color: #ccc;
}
.Nodata2 > div > img {
  width: 100%;
}
.Nodata2 > div > div {
  text-align: center;
}
// 暂无数据结束
.tablename {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}
.tablename > div:first-child,
.tablename > div:nth-child(2) {
  width: 35%;
  text-align: center;
}
.tablename > div:nth-child(3) {
  width: 30%;
  text-align: center;
}
</style>
